// From https://github.com/kbaum/browser-timezone-rails
window.BrowserTZone || (window.BrowserTZone = {});

window.BrowserTZone.setCookie = function() {
  var expires = new Date();
  expires.setDate(expires.getDate() + 365);

  document.cookie =
    "browser.timezone=" +
    encodeURIComponent(window.jstz.determine().name()) +
    "; expires=" +
    expires.toUTCString() +
    "; path=/";
};

jQuery(function() {
  return window.BrowserTZone.setCookie();
});
